import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Button from 'components/field/Button';
import Icon from 'components/global/Icon';
import Image from 'components/global/Image';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalTitle } from 'components/global/styled/Modal.styled';

import { faSquareMinus } from '@fortawesome/pro-regular-svg-icons';
import { faRotate } from '@fortawesome/pro-solid-svg-icons';

import * as S from './DeactivateModule.styled';

const DeactivateModule = NiceModal.create(({ updateModule, isLoading }) => {
	const modal = useModal();
	const { t } = useTranslation();
	const { selectedModule: module } = useSelector((state) => state.otoPackageList);

	const handleDeactivateModule = async () => {
		await updateModule(false);
		modal.remove();
	};

	return (
		<Modal maxWidth="x-small" fullwidth closeButton className="deactivate-module-confirmation">
			<ModalTitle>
				<Typography variant="p1">deactivateModule</Typography>
			</ModalTitle>
			<S.Container>
				<S.LogoContainer>
					<Image width="6rem" height="6rem" url={module?.moduleIcon} />
					<Icon icon={faRotate} fontSize="3rem" />
					<Image
						width="6rem"
						height="6rem"
						url="https://storage.googleapis.com/tryoto-public/public/assets/images/otoLogo.png"
					/>
				</S.LogoContainer>
				<Typography variant="p2" fontWeight="500" noWrap align="center">
					{t('deactivateModuleConfirmation', {
						moduleName: t(module?.slug)
					})}
				</Typography>
				<Typography variant="p3" color="var(--content-3)" noWrap align="center">
					deactivateModuleSubtitle
				</Typography>
			</S.Container>
			<ModalActions>
				<Button label="cancel" onClick={() => modal.remove()} variant="action" />
				<Button
					label="deactivateModule"
					onClick={handleDeactivateModule}
					icon={faSquareMinus}
					loading={isLoading}
					css={S.DeactivateButtonCss}
				/>
			</ModalActions>
		</Modal>
	);
});

export default DeactivateModule;
